import { action } from '@ember/object';
import Component from '@glimmer/component';

import type { RadiobuttonItemInfo } from 'webapp-types';
import { BlockVisualization, ChartLegendPosition } from 'webapp/enums/enums';

import FormRadiobuttonGroupComponent from 'webapp/components/form/radiobutton-group';

import type Block from 'webapp/models-custom/block';
import type BlockSetup from 'webapp/models-custom/block-setup';

interface Args {
	blockM: Block;
}

export default class BlockSettingsLegendPositionComponent extends Component<Args> {
	get block(): Block {
		return this.args.blockM;
	}

	get blockSetup(): BlockSetup {
		return this.block.blockSetup;
	}

	get selected(): ChartLegendPosition {
		return this.block.legendPosition;
	}

	get isBlockVisualizationPie(): boolean {
		return this.blockSetup.visualizationType === BlockVisualization.PIE;
	}

	get options(): RadiobuttonItemInfo[] {
		const isPie = this.isBlockVisualizationPie;

		const options: RadiobuttonItemInfo[] = [
			{
				value: ChartLegendPosition.OFF,
				label: '',
				tooltipText: 'Off',
				icon: 'Block',
				iconSize: 'lg',
			},
		];

		if (isPie) {
			options.push({
				value: ChartLegendPosition.OUTSIDE,
				label: '',
				tooltipText: 'Spider legs',
				icon: 'LegendPositionPieSpiderLegs',
				iconSize: 'lg',
			});
		}

		options.push({
			value: ChartLegendPosition.BOTTOM,
			label: '',
			tooltipText: 'Bottom',
			icon: isPie ? 'LegendPositionPieBottom' : 'PositionBottom',
			iconSize: 'lg',
		});

		// if (!isPie) {
		// 	options.push({
		// 		value: ChartLegendPosition.RIGHT,
		// 		label: '',
		// 		tooltipText: 'Right',
		// 		icon: 'PositionRight',
		// 		iconSize: 'lg',
		// 	});
		// }

		return options;
	}

	@action
	changeSelected(value: AnySimpleValue): void {
		const selected = value as ChartLegendPosition;
		const block = this.block;
		block.legendPosition = selected;
		block.blockSetup.saveBlock();

		// tracking
		let legend_position = '';
		switch (selected) {
			case ChartLegendPosition.OFF:
				legend_position = 'off';
				break;
			case ChartLegendPosition.BOTTOM:
				legend_position = 'bottom';
				break;
			case ChartLegendPosition.TOP:
				legend_position = 'top';
				break;
			case ChartLegendPosition.LEFT:
				legend_position = 'left';
				break;
			case ChartLegendPosition.RIGHT:
				legend_position = 'right';
				break;
			case ChartLegendPosition.OUTSIDE:
				legend_position = 'spider_legs';
				break;
		}
		block.blockSetup.trackBlockPropertySettingsChangeEvent({ legend_position });
	}
	<template>
		<div class="row legend-position {{if this.isBlockVisualizationPie 'legend-position--pie'}}">
			<label>Legend position</label>
			<FormRadiobuttonGroupComponent
				class="radiobutton-switcher"
				@name="legendPosition"
				@selected={{this.selected}}
				@options={{this.options}}
				@onChange={{this.changeSelected}}
				@theme="dark-blue"
			/>
		</div>
	</template>
}
